import { ColumnSort, SortingState, Updater } from '@tanstack/react-table'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

interface useUrlSyncedSortingReturn {
  sorting: SortingState
  setSorting: (updaterOrValue: Updater<ColumnSort[]>) => void
}

export const useUrlSyncedSorting = (
  defaultSorting: SortingState = [],
): useUrlSyncedSortingReturn => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [sorting, setSorting] = useState<SortingState>(() => {
    if (searchParams.has('sorting')) {
      return [
        {
          id: searchParams.get('sorting')!.split(':')[0],
          desc: searchParams.get('sorting')!.split(':')[1] === 'desc',
        },
      ]
    }
    return defaultSorting
  })

  useEffect(() => {
    // Read directly from window.location.search to avoid stale React state
    // when multiple hooks use setSearchParams concurrently
    setSearchParams(() => {
      const params = new URLSearchParams(window.location.search)
      if (sorting.length > 0) {
        params.set('sorting', `${sorting[0].id}:${sorting[0].desc ? 'desc' : 'asc'}`)
      } else {
        params.delete('sorting')
      }
      return params
    })
  }, [sorting, setSearchParams])

  return {
    sorting,
    setSorting,
  }
}
